import React from "react";
import Portfolios from "./Portfolios";

function Portfolios2() {
  return <Portfolios basePath="/work-details" />;
}

export default Portfolios2;
